<template lang="pug">
  .support-settings(v-loading="loading")
    .support-page-header
      h1 Soporte · Configuración
      .support-page-actions
        el-button(type="primary" :loading="saving" @click="save") 💾 Guardar

    el-row(:gutter="16")
      el-col(:span="12")
        el-card
          h3 Asistente
          el-form(label-width="180px" label-position="left" size="small")
            el-form-item(label="Habilitado")
              el-switch(v-model="form.enabled")
            el-form-item(label="Modelo")
              el-select(v-model="form.assistant.model")
                el-option(label="gpt-4o-mini (default)" value="gpt-4o-mini")
                el-option(label="gpt-4o (mejor razonamiento)" value="gpt-4o")
            el-form-item(label="Umbral de confianza")
              el-slider(v-model="confidenceThresholdPct" :min="0" :max="100" :step="5" show-input)
            el-form-item(label="Max mensajes por conversación")
              el-input-number(v-model="form.assistant.maxMessagesPerConversation" :min="1" :max="200")
            el-form-item(label="Max conversaciones por usuario/día")
              el-input-number(v-model="form.assistant.maxConversationsPerUserPerDay" :min="1" :max="100")
            el-form-item(label="System prompt (override)")
              el-input(type="textarea" v-model="form.assistant.systemPrompt" :rows="6" placeholder="Vacío = usar el default")

      el-col(:span="12")
        el-card
          h3 Notificaciones por email
          el-form(label-width="180px" label-position="left" size="small")
            el-form-item(label="Habilitado")
              el-switch(v-model="form.notifications.email.enabled")
            el-form-item(label="Destinatarios")
              el-input(v-model="emailRecipientsRaw" placeholder="op1@empresa.com, op2@empresa.com")
              .support-hint Separar por coma
            el-form-item(label="Solo escalaciones")
              el-switch(v-model="form.notifications.email.escalationOnly")
        el-card(style="margin-top: 16px")
          h3 Slack (V2 — placeholder)
          p.support-hint Pendiente para V2. El webhook se configurará desde acá cuando esté disponible.
</template>

<script>
import supportService from "@/services/support";

/**
 * @component SupportSettings
 * @description Configuración del módulo de soporte por org (Fase 6 —
 *              UC-REG-098). Edita assistant config + notificaciones email.
 *              Slack queda placeholder para V2.
 * @example <SupportSettings />
 */
export default {
  name: "SupportSettings",
  data() {
    return {
      loading: false,
      saving: false,
      form: {
        enabled: false,
        assistant: {
          provider: "openai",
          model: "gpt-4o-mini",
          confidenceThreshold: 0.7,
          maxMessagesPerConversation: 30,
          maxConversationsPerUserPerDay: 20,
          systemPrompt: "",
        },
        notifications: {
          email: { enabled: false, recipients: [], escalationOnly: true },
        },
      },
      emailRecipientsRaw: "",
    };
  },
  computed: {
    confidenceThresholdPct: {
      get() {
        return Math.round(
          (this.form.assistant.confidenceThreshold || 0.7) * 100
        );
      },
      set(v) {
        this.form.assistant.confidenceThreshold = v / 100;
      },
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    /**
     * @description Carga config desde backend.
     */
    async load() {
      this.loading = true;
      try {
        const cfg = await supportService.getConfig();
        Object.assign(this.form, cfg);
        const r =
          (cfg.notifications &&
            cfg.notifications.email &&
            cfg.notifications.email.recipients) ||
          [];
        this.emailRecipientsRaw = r.join(", ");
      } catch (err) {
        this.$message.error("No pude cargar la config.");
      } finally {
        this.loading = false;
      }
    },
    /**
     * @description Guarda config.
     */
    async save() {
      this.saving = true;
      try {
        const payload = JSON.parse(JSON.stringify(this.form));
        payload.notifications.email.recipients = this.emailRecipientsRaw
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
        await supportService.updateConfig(payload);
        this.$message.success("Configuración guardada.");
      } catch (err) {
        this.$message.error("No pude guardar.");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.support-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  h1 {
    margin: 0;
    font-size: 22px;
    color: #002d5e;
  }
}
.support-hint {
  font-size: 11px;
  color: #6b7294;
}
</style>
